'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _reactIntl = require('react-intl');

var _en = require('../i18n/en.json');

var _en2 = _interopRequireDefault(_en);

var _helpBot = require('./help-bot');

var _helpBot2 = _interopRequireDefault(_helpBot);

var _store = require('./store');

var _store2 = _interopRequireDefault(_store);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var HelpBotContainer = function (_Component) {
  _inherits(HelpBotContainer, _Component);

  function HelpBotContainer() {
    _classCallCheck(this, HelpBotContainer);

    return _possibleConstructorReturn(this, (HelpBotContainer.__proto__ || Object.getPrototypeOf(HelpBotContainer)).apply(this, arguments));
  }

  _createClass(HelpBotContainer, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _reactRedux.Provider,
        { store: _store2.default },
        _react2.default.createElement(
          _reactIntl.IntlProvider,
          { locale: this.props.market, messages: _en2.default },
          _react2.default.createElement(_helpBot2.default, this.props)
        )
      );
    }
  }]);

  return HelpBotContainer;
}(_react.Component);

/**
 * Property definitions.
 *
 * @type {Object}
 * @public
 */


HelpBotContainer.propTypes = {
  env: _propTypes2.default.string.isRequired,
  market: _propTypes2.default.string.isRequired,
  sessionId: _propTypes2.default.string.isRequired,
  onChatMessage: _propTypes2.default.func,
  productId: _propTypes2.default.string,

  // TODO: these should be changed/removed
  chatbotsApiUrl: _propTypes2.default.string,
  locationChange: _propTypes2.default.func,
  region: _propTypes2.default.string,
  welcomeIntent: _propTypes2.default.string
};

exports.default = HelpBotContainer;